import { CheckCircle2, Loader2 } from 'lucide-react';
import { Card, CardContent } from 'Assessment/src/components/ui/card';
import { useColor } from "components/ui/ColorContext";

interface SuccessOverlayProps {
  show: boolean;
  message: string;
  variant?: 'success' | 'loading';
  style?: React.CSSProperties;
}



export const SuccessOverlay = ({ show, message, variant = "success" }: SuccessOverlayProps) => {
  const { primaryColor } = useColor(); 
   if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center animate-in fade-in duration-300">
      <Card className="w-full max-w-md mx-4 shadow-lg animate-in zoom-in-95 duration-300"
      style={{
          fontSize: "16px" ,
            background: `
    linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.65) 0%,
      ${primaryColor}44 25%,
      rgba(0, 0, 0, 0.75) 70%,
      rgba(0, 0, 0, 0.85) 100%
    )
  `,

    borderColor: `${primaryColor}aa`,
    boxShadow: `
      0 0 0 1px ${primaryColor}66,
      0 0 18px ${primaryColor}88,
      inset 0 0 14px ${primaryColor}33
    `,
  }}>
        <CardContent className="pt-6 pb-6 text-center">
          <div className="flex justify-center mb-4">
            {variant === 'success' ? (
              <div className="rounded-full bg-green-100 dark:bg-green-900/50 p-3">
                <CheckCircle2 className="h-12 w-12 text-green-600 dark:text-green-400" />
              </div>
            ) : (
              <div className="rounded-full bg-primary/10 p-3">
                <Loader2 className="h-12 w-12 text-primary animate-spin" />
              </div>
            )}
          </div>
          <h3 className="text-xl font-semibold mb-2">{message}</h3>
        </CardContent>
      </Card>
    </div>
  );
};
